import React, { useEffect, useState, useContext, useMemo } from "react";
import { useLocation } from 'react-router-dom';
import { Typography, Box, Backdrop, CircularProgress, InputAdornment, TextField, MenuItem, Button, Stack, TableCell, AppBar, Toolbar, IconButton, Dialog, Select} from "@mui/material";
import { Search, Edit, InsertDriveFileOutlined, InfoOutlined, PrintOutlined, Close, Paid, Warning, Delete } from '@mui/icons-material';
import Header from "../layout/Header";
import SortTotalTable from "../ui/sortTotalTable";
import { API } from "../../conf";
import { Context } from "../../App";
import pdfMake from "pdfmake/build/pdfmake";
import {bord_versement} from "../../asset/pdfmaker";
import moment from 'moment';
import { snapToSaturday } from '../../utils/dateUtils';
import pdfFonts from "pdfmake/build/vfs_fonts";
import VersHistory from "../sections/vers-history";
import Graph from "../ui/graph";
import EditVerseForm from "../forms/edit-verse-form";
import FedPartVerseForm from "../forms/fedpart-verse-form";
pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

export default function JrnVers() {
    const { updateConnect } = useContext(Context)
    const editCol = {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:agent.level>2 ? '220px' : '150px'}} >
    {eglise?.have_banque && !row.is_cloture && !row.is_valid && <IconButton aria-label="chèque/virement" onClick={()=>{setVers(row); manage_dialog(true, 'verseFed')}}><Paid fontSize="small"/></IconButton>}
    <IconButton aria-label="modifier" onClick={()=>{setVers(row); manage_dialog(true, 'edit')}} disabled={(row.is_cloture||row.is_valid)&&agent?.level<3}><Edit fontSize="small"/></IconButton>
    <IconButton aria-label="Edit bordereau de versement" onClick={()=>get_bdr_versement(row)}><InsertDriveFileOutlined fontSize="small"/></IconButton>
    <IconButton aria-label="imprimer" onClick={()=>print_bdr(row)}><PrintOutlined fontSize="small"/></IconButton>
    <IconButton aria-label="informations complémentaires" onClick={()=>{setVers(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
    {row.is_error&&agent?.level>2&&<IconButton aria-label="corriger" onClick={()=>{setVers(row); manage_dialog(true, 'warning')}}><Warning fontSize="small"/></IconButton>}
    {agent?.level>2&&!row.is_cloture&&<IconButton aria-label="supprimer"  onClick={()=>{setVers(row); manage_dialog(true, 'delete')}}><Delete fontSize="small"/></IconButton>}
</TableCell>}
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const [loading, setLoad] = useState(true)
    const [min_date, setMin] = useState()
    const [max_date, setMax] = useState()
    const [start_date, setStart] = useState('')
    const [end_date, setEnd] = useState('')
    const [search_input, setSearch] = useState('')
    const [verses, setVerses] = useState()
    const [vers, setVers] = useState()
    const [pdf, setPdf] = useState()
    const [action, setAction] = useState()
    const [open, setOpen] = useState(false)
    const [filter, setFilter] = useState(['tous'])
    const filters = [
        {name:'tous', value: v=>true}, 
        {name:'en attente de validation', value: v=>!v.is_valid&&!v.is_cloture}, 
        {name:'validé', value: v=>v.is_valid}, 
        {name:'clôturé', value: v=>v.is_cloture}, 
        {name:'erreur, correction nécessaire', value: v=>v.is_error},
        {name:'petite-caisse', value: v=>v.petiteCaisse?.length>0},
        {name:'versement FEAM', value: v=>v.fedRepartition?.especes?.length>0||v.fedRepartition?.cheques?.length>0||v.fedRepartition?.virement?.montant>0||v.fedRepartition?.retrait?.filter(es=>es.montant>0&&es.count>0).length>0},
        {name:'banque église', value: v=>eglise?.have_banque&&(v.banqueEglise?.especes?.length>0||v.banqueEglise?.cheques?.length>0)}
    ]

    const eglise = useMemo(()=>{
        if (organisation && organisation.type==='église') {
            return organisation
        } else if (egliseId!=='') {
            return eglises.find(el=> el._id === egliseId)
        } else return
    }, [eglises, egliseId, organisation])

    const table = useMemo(()=>{
        const col = [
            {header: "N°", sortable: true, sortBy:(el)=>el.bordereau_num, row: (row, index)=><TableCell key={index} align="center" >{row.bordereau_num}</TableCell>},
            {header: "Statut", sortable: true, sortBy:(el)=>getStatusColors(el)?.text?.toLowerCase(), 
                row: (row, index)=><TableCell key={index} align="center" sx={{fontWeight:row.is_cloture?'bold':'normal', color: getStatusColors(row).color, }} >{getStatusColors(row).text}</TableCell>},
            {header: "Date", sortable: true, sortBy:(el)=>new Date(el.date_jour).getTime(), row: (row, index)=><TableCell key={index} align="center" >{moment.utc(row.date_jour).format('DD/MM/YYYY')}</TableCell>},
            {header: "Date dons", sortable: true, sortBy:(el)=>new Date(el.dateDons).getTime(), row: (row, index)=><TableCell key={index} align="center" >{snapToSaturday(row.dateDons).format('DD/MM/yyyy')}</TableCell>},
            {header: "Versement FEAM", sortable: true, isNumeric: true, getValue: row => row.fedRepartition?.especes.reduce((tt,es)=>tt+es.count*es.montant,0)+row.fedRepartition?.cheques.reduce((tt,ch)=>tt+ch.montant,0)+(row.fedRepartition?.virement?.montant??0)+(row.fedRepartition.retrait.filter(es=>es.montant>0&&es.count>0).reduce((tt,es)=>tt+es.montant*es.count,0)??0),
                formatTotal: value=> value.toFixed(2) + '€', sortBy:row=>row.fedRepartition?.especes.reduce((tt,es)=>tt+es.count*es.montant,0)+row.fedRepartition?.cheques.reduce((tt,ch)=>tt+ch.montant,0)+(row.fedRepartition?.virement?.montant??0)+(row.fedRepartition.retrait.filter(es=>es.montant>0&&es.count>0).reduce((tt,es)=>tt+es.montant*es.count,0)??0), 
                row: (row, index)=><TableCell key={index} align="center" sx={{minWidth:'200px'}}>{(row.fedRepartition?.especes.reduce((tt,es)=>tt+es.count*es.montant,0)+row.fedRepartition?.cheques.reduce((tt,ch)=>tt+ch.montant,0)+(row.fedRepartition?.virement?.montant??0)+(row.fedRepartition.retrait.filter(es=>es.montant>0&&es.count>0).reduce((tt,es)=>tt+es.montant*es.count,0)??0)).toFixed(2)}€</TableCell>},
            {header: "Petite-caisse", sortable: true, isNumeric: true, formatTotal: value=> value.toFixed(2) + '€', getValue: row => row.petiteCaisse?.reduce((tt, es)=>tt+es.count*es.montant,0), row: (row, index)=><TableCell key={index} align="center" sx={{minWidth:'200px'}} >{row.petiteCaisse?.reduce((tt, es)=>tt+es.count*es.montant,0).toFixed(2)}€</TableCell>},
            {header: "Utilisateur", sortable: true, sortBy:(el)=>el.creator, row: (row, index)=><TableCell key={index} align="center" sx={{minWidth:'120px', textTransform:'capitalize'}} >{row.creator}</TableCell>},
        ]
        return eglise?.have_banque ? 
        [...col.slice(0, 6), {header: "Banque église", sortable: true, isNumeric:true,
            formatTotal: value=> value.toFixed(2) + '€', getValue: row => row.banqueEglise?.especes.reduce((tt,es)=>tt+es.count*es.montant,0)+row.banqueEglise?.cheques.reduce((tt,ch)=>tt+ch.montant,0),
            sortBy:(el)=>el.banqueEglise?.especes?.reduce((tt,es)=>tt+es.count*es.montant,0)+el.banqueEglise?.cheques.reduce((tt,ch)=>tt+ch.montant,0), 
            row: (row, index)=><TableCell key={index}>{(row.banqueEglise?.especes?.reduce((tt,es)=>tt+es.count*es.montant,0)+row.banqueEglise?.cheques.reduce((tt,ch)=>tt+ch.montant,0)).toFixed(2)}€</TableCell>}, 
        col[6]] 
        : col
    },[eglise])

    function getStatusColors(vers){
        if (vers.is_cloture) {
            return {color: 'black', text: 'Clôturé'}
        } else if (vers.is_error) {
            return {color: 'red', text: 'Erreur, correction nécessaire'}
        } else if (vers.is_fixed) {
            return {color: 'darkorange', text: 'Corrigé'}
        } else if (vers.is_valid) {
            return {color: 'green', text: 'Validé'}
        }
        return {color: 'black', text: 'En attente de validation'}
    }

    function manage_dialog(status, action="") {
        setOpen(status)
        setAction(action)
        if (!status) {
            setVers()
            setPdf()
        }
    }

    function create_bdr_versement(vers) {return new Promise((resolve, reject) => {
        if (organisation.type==='fédération') {
            const pdfDocGenerator = pdfMake.createPdf(bord_versement(organisation, vers, eglise));
            pdfDocGenerator.getBlob((blob) => {
                resolve(URL.createObjectURL(blob))
            });
        } else {
            fetch(API.concat(`/eglises/by/${JSON.stringify({type:'fédération'})}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        const pdfDocGenerator = pdfMake.createPdf(bord_versement(json[0], vers, eglise));
                        pdfDocGenerator.getBlob((blob) => {
                            resolve(URL.createObjectURL(blob))
                        });
                    } else resolve()
                }
            })
        }
    })}

    function get_bdr_versement(vers) {
        setLoad(true)
        create_bdr_versement(vers).then((pdf_url) => {
            setPdf(pdf_url)
            manage_dialog(true, 'pdf')
            setLoad(false)
        })
    }

    function print_bdr(vers) {
        setLoad(true)
        create_bdr_versement(vers).then(pdf_url=>{
            const win = window.open(pdf_url, '_blank');
            if (win) {
                win.onload = function() {
                win.print();
                };
            } else {
                alert('Impossible d\'ouvrir le PDF et de l\'imprimer');
            }
            setLoad(false)
        })
    }

    function getVerses(end_date, start_date) {
        setLoad(true)
        fetch(API.concat(`/versements/agent/by/${JSON.stringify({eglise: eglise.number, $and: [{date_jour: {$lte: new Date(end_date).setTime(new Date(end_date).getTime()+24*60*60*1000)}}, { date_jour: {$gte: new Date(start_date)}}]})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json();
                    const sorted = await json.sort((a, b) => new Date(a.dateDons).getTime() - new Date(b.dateDons).getTime())
                    setVerses(sorted); setLoad(false)
                }else setLoad(false)
            }
        })
    }

    function getGraphData() {
        const data0 = [
            {label:'Versement FEAM', value: verses.reduce((tt,v)=>tt+v.fedRepartition.especes.reduce((t,es)=>t+es.montant*es.count,0)+v.fedRepartition.cheques.reduce((t,ch)=>t+ch.montant,0)+v.fedRepartition.retrait.reduce((t,es)=>t+es.montant*es.count,0)+(v.fedRepartition.virement?.montant?? 0), 0)},
            {label:'Petite-caisse', value: verses.reduce((tt,v)=>tt+v.petiteCaisse.reduce((t,es)=>t+es.montant*es.count,0), 0)}
        ]
        let data = eglise?.have_banque? [...data0,{label:'Banque église', value: verses.reduce((tt,v)=>tt+v.banqueEglise.especes.reduce((t,es)=>t+es.montant*es.count,0)+v.banqueEglise.cheques.reduce((t,ch)=>t+ch.montant,0), 0)}] : data0
        return data
    }

    function get_lineargraph_data() {
        const dates = [...new Set(verses.map(vrs=>vrs.date_jour))]
        const data0 = [
            {label:'Versement FEAM', values: dates.map(date => verses.filter(vrs=> vrs.date_jour===date).reduce((tt,v)=>tt+v.fedRepartition.especes.reduce((t,es)=>t+es.montant*es.count,0)+v.fedRepartition.cheques.reduce((t,ch)=>t+ch.montant,0)+v.fedRepartition.retrait.reduce((t,es)=>t+es.montant*es.count,0)+(v.fedRepartition.virement?.montant?? 0), 0))},
            {label:'Petite-caisse', values: dates.map(date => verses.filter(vrs=> vrs.date_jour===date).reduce((tt,v)=>tt+v.petiteCaisse.reduce((t,es)=>t+es.montant*es.count,0), 0))}
        ]
        let data = eglise?.have_banque? [...data0,{label:'Banque église', values: dates.map(date => verses.filter(vrs=> vrs.date_jour===date).reduce((tt,v)=>tt+v.banqueEglise.especes.reduce((t,es)=>t+es.montant*es.count,0)+v.banqueEglise.cheques.reduce((t,ch)=>t+ch.montant,0), 0))}] : data0
        return {dates, data}
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(vers) {    
        return vers.bordereau_num+' '+[...(vers.fedRepartition?.cheques??[]), ...(vers.banqueEglise?.cheques??[])].reduce((tt, cq)=>tt+cq.num_cheque+' ','')
    }

    async function handleDelete() {
        try {
            manage_dialog(false);
            setLoad(true);

            if (!vers || !vers._id) return;
            const response = await fetch(API.concat(`/versements/${vers._id}`), {
                method: 'DELETE',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            });
            if (response.ok) {
                // Handle successful deletion
                setVerses(verses.filter(v => v._id !== vers._id));
            } else {
                // Handle error
                if(response.status<500) {
                    const message = await response.text();
                    alert(message);
                } else alert('Erreur lors de la suppression du versement');
                console.error('Error deleting versement:', response.statusText);
            }
        } catch (error) {
            console.error('Error deleting versement:', error);
        } finally {
            setLoad(false);
        }
    }

    useEffect(()=>{
        if (eglise&&eglise.number) {
            const urlKey = new URLSearchParams(location.search).get('key')
            if (urlKey) {
                const ex = parseInt(sessionStorage.getItem('exercice'))
                const start = `${ex}-01-01`
                const end = `${ex}-12-31`
                setStart(start); setEnd(end)
                getVerses(end, start)
                return
            }
            fetch(API.concat(`/versements/${eglise.number}/dates/min_max`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        if(json && Object.keys(json).includes("mindate") && Object.keys(json).includes("maxdate")){
                            setMin(new Date(json?.mindate))
                            setMax(new Date(json?.maxdate)); setEnd(moment.utc(json.maxdate).format('yyyy-MM-DD'))
                            const month_before = moment.utc(json.maxdate).add(-1,'month')
                            setStart(month_before.isAfter(moment.utc(json.mindate))?month_before.format('yyyy-MM-DD'):moment.utc(json.mindate).format('yyyy-MM-DD'))
                            getVerses(json.maxdate, month_before.isAfter(moment.utc(json.mindate))?month_before.format('yyyy-MM-DD'):json.mindate)
                        } else {
                            setMin(new Date(Date.now()).setDate(0))
                            setMax(new Date()); setEnd(moment.utc(Date.now()).format('yyyy-MM-DD'))
                            setLoad(false)
                        }
                    }else setLoad(false)
                }
            })
        }
    }, [eglise])

    useEffect(()=>{
        if (organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    const location = useLocation()
    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
        const key = new URLSearchParams(location.search).get('key')
        if (key) setSearch(key)
    },[])
    
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Journal des Versements</Typography>
            {organisation&&organisation.type==='fédération'&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)setVerses([]); return e.target.value})}>
                {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', marginInline:3}}>
                <Stack direction='row' spacing={2} sx={{alignItems:'center'}}>
                    <Typography fontWeight={600} fontSize={16}>Période:</Typography>
                    <TextField
                    size="small"
                    sx={{minWidth:"120px"}}
                    margin="normal"
                    InputLabelProps={{shrink: true}}
                    label="Date de début"
                    type='date'
                    value={start_date}
                    inputProps={min_date&&max_date&&{min: new Date(min_date).toISOString().split("T")[0], max: new Date(max_date).toISOString().split("T")[0]}}
                    onChange={(event)=> {
                        setStart(event.target.value)
                        if (end_date!=='' && (new Date(end_date).getTime() - new Date(event.target.value).getTime()) < 0) {
                            setEnd('')
                        } 
                    }}
                    />
                    <TextField
                    size="small"
                    sx={{minWidth:"120px"}}
                    margin="normal"
                    InputLabelProps={{shrink: true}}
                    label="Date de fin"
                    type="date"
                    value={end_date}
                    inputProps={min_date&&max_date&&{min: new Date(start_date!=='' ? start_date : min_date).toISOString().split("T")[0], max: new Date(max_date).toISOString().split("T")[0]}}
                    onChange={(event)=> {
                        setEnd(event.target.value)
                        if (start_date!=='' && (new Date(event.target.value).getTime() - new Date(start_date).getTime()) < 0) {
                            setStart('')
                        }
                    }}
                    />
                    <Button variant="contained" disabled={start_date===''||end_date===''||!eglise} onClick={()=>getVerses(end_date, start_date)}>Appliquer</Button>
                </Stack>
                <Button variant="contained" onClick={()=> {manage_dialog(true, 'graph')}} disabled={!verses?.length>0}>Graph</Button>
            </Box>

            <Stack direction='row' display='flex' spacing={2} sx={{alignItems:'center', marginInline:3, mt:2}}>
                <Box sx={{flex:1, display:'flex', flexDirection:'column', alignItems:'center'}}><TextField label="Rechercher un versement par N° ou par N°chèques" size="small" disabled={!verses?.length>0}
                sx={{width:'60%', minWidth:'250px', alignSelf:'center'}}
                value={search_input} onChange={(event)=>setSearch(event.target.value)}
                InputProps={{endAdornment: (<InputAdornment position="end"><Search /></InputAdornment>)}}/></Box>

                {agent.level>2 &&<Select multiple size="small" value={filter} 
                onChange={e=>setFilter(previous=> e.target.value.filter(value=>!previous.includes(value)&&value==='tous').length>0||e.target.value.length===0 ? ['tous'] : e.target.value.filter(value=>value!=='tous'))}
                sx={{width:'20%', minWidth:'200px', marginLeft:'auto'}}>
                    {filters.map((f, index)=><MenuItem key={index} value={f.name} sx={{textTransform:'capitalize'}}>{f.name}</MenuItem>)}
                </Select>}
            </Stack>
                    
            <Box sx={{paddingX:'20px'}}>
                {verses && <SortTotalTable data={verses.filter(vers=> normalize(get_searchable(vers)).includes(normalize(search_input))&&filters.filter(f=>filter.includes(f.name)).some(f=>f.value(vers)))} table={table.concat([editCol])} rowsPerPage={10} rowsPerPageOptions={[10, 25, 50, 100]}/>}
            </Box>

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>

            <Dialog fullScreen={action==='edit'} open={open} onClose={()=>manage_dialog(false, '')} maxWidth={action==='delete'?'xs':['verseFed'].includes(action)?'sm':'md'} fullWidth PaperProps={{sx : {overflow: action==='pdf'?'hidden':'auto'}}} >
                {action!=='edit'&&<IconButton sx={{ alignSelf:'end'}} onClick={()=>{manage_dialog(false, '')}}><Close/></IconButton>}
                {action==='verseFed' && vers && <FedPartVerseForm {...{vers, updateVersement:(update)=>setVerses(old=>{old[old.findIndex(item=>item._id===update._id)]= update; return [...old]}), handleClose:()=>manage_dialog(false, '')}}/>}
                {action==='info' && vers && <VersHistory {...{eglise, vers}}/>}
                {action==='pdf' && pdf && <embed src={pdf}  height='600px' style={{marginInline:'20px'}} type="application/pdf" />}
                {action==='edit' && vers && <Box display='flex' flexDirection='column' flex={1} >
                    <AppBar sx={{ position: 'relative' }} color="grey">
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Modification
                        </Typography>
                        <Button autoFocus color="inherit" onClick={()=>{manage_dialog(false, '')}}>
                        Fermé
                        </Button>
                    </Toolbar>
                    </AppBar>

                    <EditVerseForm eglise={eglise} versement={JSON.parse(JSON.stringify(vers))} setVerses={edited=>setVerses(old=>[...old.filter(v=>v._id!==edited._id), edited].sort((a,b)=>moment(a.date_jour).isBefore(moment(b.date_jour)?1:-1)))} close={()=> manage_dialog(false, '')} />
                </Box>}
                {action==='delete' && <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', px:2, textAlign:'center', pb:2}}>
                    <Typography variant="subtitle1">Êtes-vous sûr de vouloir supprimer ce versement ?</Typography>
                    {vers?.is_valid
                        ? <Typography variant="body2">Cette action est irréversible. Le versement étant validé, toutes les écritures comptables associées (comptes de liaison, dîme, offrandes) seront annulées et les dons remis en état non versé.</Typography>
                        : <Typography variant="body2">Cette action est irréversible et les dons qui n'appartiennent pas à un autre versement seront marqués comme non versés.</Typography>
                    }
                    <Stack direction='row' spacing={2} sx={{marginTop:2}}>
                        <Button onClick={()=> manage_dialog(false, '')}>Annuler</Button>
                        <Button variant="contained" color="carmine" onClick={handleDelete}>Supprimer</Button>
                    </Stack>
                </Box>}
                {action==='graph' && <Graph data={getGraphData()} tt_label='Total' line_data = {get_lineargraph_data()}/>}
            </Dialog>
        </div>
    )
}